(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dg-holiday-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const search = root.querySelector('[data-holiday-search]');
    const cards = [...root.querySelectorAll('[data-holiday-card]')];
    const groups = [...root.querySelectorAll('[data-holiday-category]')];
    const links = [...root.querySelectorAll('[data-holiday-category-link]')];
    const filters = [...root.querySelectorAll('[data-holiday-diet]')];
    const clearButtons = [...root.querySelectorAll('[data-holiday-clear]')];
    const results = root.querySelector('[data-holiday-results]');
    const empty = root.querySelector('[data-holiday-empty]');
    const navigation = root.querySelector('.dg-holiday-navigation');
    let dietary = 'all';
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const filter = () => {
      const term = normalize(search.value.trim());
      let count = 0;
      cards.forEach(card => {
        const diets = (card.dataset.dietary || '').split(' ');
        const visible = normalize(card.dataset.search || '').includes(term) && (dietary === 'all' || diets.includes(dietary));
        card.hidden = !visible;
        if (visible) count++;
      });
      groups.forEach(group => {
        const count = group.querySelectorAll('[data-holiday-card]:not([hidden])').length;
        group.hidden = count === 0;
        const link = links.find(link => link.dataset.holidayCategoryLink === group.dataset.holidayCategory);
        if (link) { link.querySelector('[data-holiday-category-count]').textContent = count; link.setAttribute('aria-disabled', String(count === 0)); link.tabIndex = count ? 0 : -1; }
      });
      results.textContent = root.dataset.resultTemplate.replace('{count}', count);
      empty.hidden = count > 0;
      clearButtons.forEach(button => { if (button.classList.contains('dg-holiday-clear')) button.hidden = !term && dietary === 'all'; });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.holidayDiet === dietary)));
    };
    search.addEventListener('input', filter);
    filters.forEach(button => button.addEventListener('click', () => { dietary = button.dataset.holidayDiet; filter(); }));
    clearButtons.forEach(button => button.addEventListener('click', () => { dietary = 'all'; search.value = ''; filter(); search.focus(); }));
    const mobile = window.matchMedia('(max-width: 900px)');
    navigation.open = !mobile.matches;
    mobile.addEventListener('change', event => { navigation.open = !event.matches; });
    root.querySelectorAll('.dg-holiday-navigation a[href^="#"]').forEach(link => link.addEventListener('click', event => { if (link.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; } if (mobile.matches) navigation.open = false; }));
    const header = document.querySelector('#shopify-section-header .site-header');
    if (header && 'ResizeObserver' in window) { const observer = new ResizeObserver(() => root.style.setProperty('--dg-header-offset', `${Math.round(header.getBoundingClientRect().height)}px`)); observer.observe(header); }
    if ('IntersectionObserver' in window) { const observer = new IntersectionObserver(entries => { entries.filter(entry => entry.isIntersecting).forEach(entry => { links.forEach(link => { if (link.hash === `#${entry.target.id}`) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current'); }); }); }, { rootMargin: '-15% 0px -65% 0px' }); groups.forEach(group => observer.observe(group)); }
    root.querySelectorAll('[data-holiday-variant]').forEach(select => select.addEventListener('change', () => { const card = select.closest('[data-holiday-card]'); const price = card.querySelector('[data-holiday-price]'); if (price) price.textContent = select.selectedOptions[0].dataset.price; }));
    root.querySelectorAll('[data-holiday-form]').forEach(form => form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const button = form.querySelector('button[type=submit]');
      if (button.disabled) return;
      const original = button.textContent;
      const error = form.querySelector('[data-holiday-error]');
      const success = form.querySelector('[data-holiday-success]');
      button.disabled = true; button.textContent = root.dataset.adding; error.hidden = true; success.hidden = true;
      try {
        const response = await fetch(form.action.replace(/\/add\/?$/, '/add.js'), { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : root.dataset.error);
        const notice = root.querySelector('[data-holiday-cart-notice]'); notice.querySelector('span').textContent = root.dataset.added; notice.hidden = false;
        success.hidden = false;
        try { const cartResponse = await fetch(`${root.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
          if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-cart-items-count]').forEach(counter => { counter.textContent = cart.item_count > 9 ? '9+' : cart.item_count; }); }
        } catch (failure) {}
      } catch (failure) { error.textContent = failure.message || root.dataset.error; error.hidden = false; }
      finally { button.disabled = false; button.textContent = original; }
    }));
    filter();
  };
  document.querySelectorAll('[data-holiday-page]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-holiday-page]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dg-holiday-review"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const search = root.querySelector('[data-holiday-search]');
    const cards = [...root.querySelectorAll('[data-holiday-card]')];
    const groups = [...root.querySelectorAll('[data-holiday-category]')];
    const links = [...root.querySelectorAll('[data-holiday-category-link]')];
    const filters = [...root.querySelectorAll('[data-holiday-diet]')];
    const clearButtons = [...root.querySelectorAll('[data-holiday-clear]')];
    const results = root.querySelector('[data-holiday-results]');
    const empty = root.querySelector('[data-holiday-empty]');
    const navigation = root.querySelector('.dg-holiday-navigation');
    let dietary = 'all';
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const filter = () => {
      const term = normalize(search.value.trim());
      let count = 0;
      cards.forEach(card => {
        const diets = (card.dataset.dietary || '').split(' ');
        const visible = normalize(card.dataset.search || '').includes(term) && (dietary === 'all' || diets.includes(dietary));
        card.hidden = !visible;
        if (visible) count++;
      });
      groups.forEach(group => {
        const count = group.querySelectorAll('[data-holiday-card]:not([hidden])').length;
        group.hidden = count === 0;
        const link = links.find(link => link.dataset.holidayCategoryLink === group.dataset.holidayCategory);
        if (link) { link.querySelector('[data-holiday-category-count]').textContent = count; link.setAttribute('aria-disabled', String(count === 0)); link.tabIndex = count ? 0 : -1; }
      });
      results.textContent = root.dataset.resultTemplate.replace('{count}', count);
      empty.hidden = count > 0;
      clearButtons.forEach(button => { if (button.classList.contains('dg-holiday-clear')) button.hidden = !term && dietary === 'all'; });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.holidayDiet === dietary)));
    };
    search.addEventListener('input', filter);
    filters.forEach(button => button.addEventListener('click', () => { dietary = button.dataset.holidayDiet; filter(); }));
    clearButtons.forEach(button => button.addEventListener('click', () => { dietary = 'all'; search.value = ''; filter(); search.focus(); }));
    const mobile = window.matchMedia('(max-width: 900px)');
    navigation.open = !mobile.matches;
    mobile.addEventListener('change', event => { navigation.open = !event.matches; });
    root.querySelectorAll('.dg-holiday-navigation a[href^="#"]').forEach(link => link.addEventListener('click', event => { if (link.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; } if (mobile.matches) navigation.open = false; }));
    const header = document.querySelector('#shopify-section-header .site-header');
    if (header && 'ResizeObserver' in window) { const observer = new ResizeObserver(() => root.style.setProperty('--dg-header-offset', `${Math.round(header.getBoundingClientRect().height)}px`)); observer.observe(header); }
    if ('IntersectionObserver' in window) { const observer = new IntersectionObserver(entries => { entries.filter(entry => entry.isIntersecting).forEach(entry => { links.forEach(link => { if (link.hash === `#${entry.target.id}`) link.setAttribute('aria-current', 'location'); else link.removeAttribute('aria-current'); }); }); }, { rootMargin: '-15% 0px -65% 0px' }); groups.forEach(group => observer.observe(group)); }
    root.querySelectorAll('[data-holiday-variant]').forEach(select => select.addEventListener('change', () => { const card = select.closest('[data-holiday-card]'); const price = card.querySelector('[data-holiday-price]'); if (price) price.textContent = select.selectedOptions[0].dataset.price; }));
    root.querySelectorAll('[data-holiday-form]').forEach(form => form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const button = form.querySelector('button[type=submit]');
      if (button.disabled) return;
      const original = button.textContent;
      const error = form.querySelector('[data-holiday-error]');
      const success = form.querySelector('[data-holiday-success]');
      button.disabled = true; button.textContent = root.dataset.adding; error.hidden = true; success.hidden = true;
      try {
        const response = await fetch(form.action.replace(/\/add\/?$/, '/add.js'), { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : root.dataset.error);
        const notice = root.querySelector('[data-holiday-cart-notice]'); notice.querySelector('span').textContent = root.dataset.added; notice.hidden = false;
        success.hidden = false;
        try { const cartResponse = await fetch(`${root.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
          if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-cart-items-count]').forEach(counter => { counter.textContent = cart.item_count > 9 ? '9+' : cart.item_count; }); }
        } catch (failure) {}
      } catch (failure) { error.textContent = failure.message || root.dataset.error; error.hidden = false; }
      finally { button.disabled = false; button.textContent = original; }
    }));
    filter();
  };
  document.querySelectorAll('[data-holiday-page]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-holiday-page]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();
})();
